import googleMap from "./social/googlemap.png";
import instagram from "./social/instagram.png";
import linkedin from "./social/linkedin.png";
import twitter from "./social/twitter.png";
import whatsapp from "./social/whatsapp.png";
import cvstudio from "./theme1_CV_Studio.png";
import mirror from "./theme1_Mirror.png";
import milestone from "./theme1_Milestone.png";
import layer from "./theme1_Layers.png";
import pdfImage from "./pdf.png";
import notificationIcon from "./notificationIcon.svg";
import familyMemberIcon from "./familyMemberIcon.svg";
import helpCenterIcon from "./helpCenter.svg";
import logOutIcon from "./logOutIcon.svg";
import selectedAllDoxIcon from "./selectedAllDox11.svg";
import selectedBusinessCardTabIcon from "./selectedBusinessCardTab.svg";
import selectedFavouriteIcon from "./selectedFavourite.svg";
import cyp_theme from "./cyp_theme8.svg";
import settingIcon from "./settingIcon.svg";
import shareIcon from "./shareIcon.svg";
import bankAccountIcon from './docTypeIcons/DoxBoxIcon/bank_account.svg';
import OtherDox from './docTypeIcons/DoxBoxIcon/OtherDox.svg';
import baptismIcon from './docTypeIcons/DoxBoxIcon/baptism.svg';
import birthCertificateIcon from './docTypeIcons/DoxBoxIcon/birth_certificate.svg';
import bookingHotelIcon from './docTypeIcons/DoxBoxIcon/booking.svg';
import carInsuranceIcon from './docTypeIcons/car.svg';
import deathCertificateIcon from './docTypeIcons/DoxBoxIcon/death.svg';
import degreeCardIcon from './docTypeIcons/DoxBoxIcon/degree.svg';
import divorceCertificateIcon from './docTypeIcons/DoxBoxIcon/divorce.svg';
import drivingLicenceDetailIcon from './docTypeIcons/DoxBoxIcon/driving_license.svg';
import employmentCardIcon from './docTypeIcons/DoxBoxIcon/employment.svg';
import idCardIcon from './docTypeIcons/DoxBoxIcon/id.svg';
import insuranceIcon from './docTypeIcons/DoxBoxIcon/insurance.svg';
import itineraryIcon from './docTypeIcons/DoxBoxIcon/itinerary.svg';
import loyaltyCardDetailIcon from './docTypeIcons/DoxBoxIcon/loyalty_card.svg';
import marriageCardIcon from './docTypeIcons/DoxBoxIcon/marriage.svg';
import passportIcon from './docTypeIcons/DoxBoxIcon/passport.svg';
import photoPassportIcon from './docTypeIcons/DoxBoxIcon/photo_passport.svg';
import residencyVisaIcon from './docTypeIcons/visa.svg';
import resumeCoverLetterIcon from './docTypeIcons/DoxBoxIcon/resume.svg';
import tenancyContractIcon from './docTypeIcons/DoxBoxIcon/tenancy.svg';
import vaccinationIcon from './docTypeIcons/DoxBoxIcon/vaccination.svg';
import willIcon from './docTypeIcons/DoxBoxIcon/will.svg';
import businessCardBackground from './businessCardBackground.png';

const images = {
  googleMap,
  instagram,
  linkedin,
  twitter,
  whatsapp,
  notificationIcon,
  familyMemberIcon,
  helpCenterIcon,
  logOutIcon,
  selectedAllDoxIcon,
  selectedBusinessCardTabIcon,
  selectedFavouriteIcon,
  cvstudio,
  milestone,
  layer,
  mirror,
  cyp_theme,
  settingIcon,
  shareIcon,
  pdfImage,
  businessCardBackground,
};

export const DOC_TYPE_ICONS = {
  bank_account: bankAccountIcon,
  baptism: baptismIcon,
  birth_certificate: birthCertificateIcon,
  booking_hotel: bookingHotelIcon,
  car_insurance: carInsuranceIcon,
  death_certificate: deathCertificateIcon,
  degree_card: degreeCardIcon,
  divorce_certificate: divorceCertificateIcon,
  driving_licence_detail: drivingLicenceDetailIcon,
  employmentCard: employmentCardIcon,
  idCard: idCardIcon,
  insurance: insuranceIcon,
  itinerary: itineraryIcon,
  loyalty_card_detail: loyaltyCardDetailIcon,
  marriageCard: marriageCardIcon,
  passport: passportIcon,
  photo_passport: photoPassportIcon,
  residency_visa: residencyVisaIcon,
  resume_cover_letter: resumeCoverLetterIcon,
  tenancy_contract: tenancyContractIcon,
  vaccination: vaccinationIcon,
  will: willIcon,
  OtherDox:OtherDox
}

export default images;
